module.exports = __webpack_public_path__ + "static/3.b5e5f3bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/3.jpg
// module id = 657
// module chunks = 196067925415476